// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_yRbUE","menuIcon":"index_menuIcon_cO7ue"};